import GlobalData from '@/app/features/global-data/facades/GlobalData';
import GlobalDataStorage from '@/app/features/global-data/facades/GlobalDataStorage';
import type { RootState } from '@/app/store';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import OrderPageModeHelper from '../helpers/OrderPageModeHelper';
import LivestreamAffiliateRefStorageHelper from '@/livestream/features/livestream-affiliate/helpers/LivestreamAffiliateRefStorageHelper';

export default function useGetGlobalData() {
    const isCanFetchData = useSelector((state: RootState) => state.globalData.isCanFetchData);
    // Hook chạy ngoài <Router> nên đọc mode/productId từ window.location.
    const mode = OrderPageModeHelper.getCurrent();
    const productId = OrderPageModeHelper.getCurrentProductId();
    // Chỉ lấy ref từ URL (cùng nguồn với lúc đặt hàng) để giá hiển thị khớp giá đơn.
    const ref = OrderPageModeHelper.getCurrentRef();

    useEffect(() => {
        LivestreamAffiliateRefStorageHelper.clearLegacyRefs();
        GlobalDataStorage.markedAsCanFetch();
    }, []);

    const { isFetched, isError, data } = useQuery({
        queryKey: ['globalData', mode, productId, ref],
        queryFn: () => GlobalData.get(mode, productId, ref),
        enabled: isCanFetchData,
        staleTime: 60 * 60 * 1000,
        retry: 2,
    });

    useEffect(() => {
        if (isFetched && data) {
            GlobalDataStorage.store(data);
        }
    }, [isFetched, data]);

    useEffect(() => {
        if (isError) {
            GlobalDataStorage.markedAsFetchError();
        }
    }, [isError]);
}
